<div>
  <form [formGroup]="agreement_Form" class="form">
    <div class="my-3 d-flex justify-content-between">
      <div></div>
      <div>
        <button class="_cancel-btn mr-2" (click)="cancelAgreement()">Cancel</button>
        <button class="_outline-btn mr-2" (click)="saveAgreement('create')" [class.disabled]="singleClick">Save</button>
        <button class="_primary-btn" (click)="saveAgreement('create_close')" [class.disabled]="singleClick">Save & Close</button>
      </div>
    </div>
    <div class="d-flex gap-3 px-1 position-relative">
      <a class="cursor-pointer del-agree" (click)="deleteAgreement()" *ngIf="this.agree?._id">
        <img [src]="common_images?.delete_icon" alt="" />
      </a>
      <div class="col-style w-50">
        <p class="_fw-600 f-14 mb-3">Agency Details</p>
        <div class="d-flex align-items-center">
          <p class="_fw-400 w-25">Agency</p>
          <ng-select
            [items]="agencyList"
            bindLabel="full_name"
            bindValue="_id"
            [searchable]="true"
            placeholder="Select Agency"
            [clearable]="true"
            (change)="getAgentList($event)"
            formControlName="agency"
            class="w-75">
          </ng-select>
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Agent</p>
          <ng-select
            [items]="agentList"
            bindLabel="full_name"
            bindValue="_id"
            [searchable]="true"
            placeholder="Select Agent"
            [clearable]="true"
            formControlName="agent"
            class="w-75">
          </ng-select>
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Project</p>
          <ng-select
            [items]="lmService?.ProjectList"
            bindLabel="Project_Name"
            bindValue="_id"
            [searchable]="true"
            placeholder="Select Project"
            [clearable]="true"
            formControlName="project_id"
            class="w-75">
          </ng-select>
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Internal Agent</p>
          <ng-select
            [items]="Users"
            bindLabel="full_name"
            bindValue="_id"
            [searchable]="true"
            placeholder="Select Internal Agent"
            [clearable]="true"
            formControlName="internal_agent"
            class="w-75">
          </ng-select>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="_fw-400 w-25">Agreement Cancelled</p>
          <p-checkbox formControlName="agreement_cancelled" [binary]="true"></p-checkbox>
        </div>
      </div>
      <div class="col-style w-50">
        <p class="_fw-600 f-14 mb-3">Agreement Details</p>
        <div class="d-flex align-items-center">
          <p class="_fw-400 w-25">Agreement Type</p>
          <ng-select
            [items]="agreement_type"
            bindLabel="tag_name"
            bindValue="tag_name"
            [searchable]="true"
            placeholder="Select Agreement Type"
            [clearable]="true"
            formControlName="agreement_type"
            class="w-75">
          </ng-select>
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Agreement Sent</p>
          <p-calendar
            formControlName="agreement_sent"
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yy"
            class="w-75"
            (onSelect)="selectDate('agreement_sent')"></p-calendar>
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Agreement Status</p>
          <ng-select
            [items]="agreement_status"
            bindLabel="tag_name"
            bindValue="tag_name"
            [searchable]="true"
            placeholder="Select Agreement Status"
            [clearable]="true"
            formControlName="agreement_status"
            class="w-75">
          </ng-select>
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Agreement Executed Date</p>
          <p-calendar
            formControlName="agreement_exe_date"
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yy"
            class="w-75"
            (onSelect)="selectDate('exe_date')"></p-calendar>
        </div>
        <div class="d-flex mt-2">
          <p class="_fw-400 w-25">Comments</p>
          <textarea spellcheck="true" autoresize="autoResize" formControlName="comments" class="w-75 text-area-style mb-2"></textarea>
        </div>
      </div>
      <div class="col-style w-50">
        <p class="_fw-600 f-14 mb-3">Commission Details</p>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Commission %</p>
          <input type="text" class="site-input w-75" formControlName="commission" />
        </div>
        <div class="d-flex align-items-center mt-2">
          <p class="_fw-400 w-25">Flat Fee</p>
          <input type="text" class="site-input w-75" formControlName="flat_fee" />
        </div>
        <div class="d-flex align-items-center my-3">
          <p class="_fw-400 w-25">Bonus</p>
          <p-checkbox formControlName="bonus" [binary]="true"></p-checkbox>
        </div>
        <div class="d-flex">
          <p class="_fw-400 w-25">Commission Comments</p>
          <textarea spellcheck="true" autoresize="autoResize" formControlName="commission_comments" class="w-75 text-area-style mb-2"></textarea>
        </div>
      </div>
    </div>
    <div class="mt-3 px-1">
      <small *ngIf="!inserted_id && !this.agree?._id">Please save your agreement before uploading any files</small>
      <div class="sticky-sidebar" *ngIf="inserted_id || this.agree?._id">
        <div class="site-card p-4 w-100 lib-content px-3 library" [ngClass]="{ 'mb-5': inserted_id || this.agree?._id?.length > 0 }">
          <app-library-view-mode
            category="useroffice"
            [propertyId]="this.agree?._id || inserted_id"
            defaultopen="Project Admin Documents"
            innerdefault="Agreements"
            [hidePropertyLibrary]="true"
            [noSideBar]="true"
            [appraisalsFolderId]="inserted_id || this.agree?._id">
          </app-library-view-mode>
        </div>
      </div>
    </div>
  </form>
</div>
